import { MeasureDetail } from 'domains/worklist/analytics/state';
import { createMarkForId, hasMark, markOnce } from './performance';

/**
 * Measure between start & end marks, but only if the start exists.
 * - Ensures the end mark exists (drops it if missing).
 * - No-ops if start is missing
 * Returns true if measured, false if skipped.
 *
 * @param metricName - The name of the metric to measure (e.g., worklist.sys.time_to_first_paint).
 * @param startMarkName - The name of the start mark (e.g., marks.Worklist.Load.Click).
 * @param endMarkName - The name of the end mark (e.g., marks.Worklist.Load.FirstPaint).
 * @param id - The identifier for the marks
 */
export const measureNowIfStarted = ({
  metricName,
  startMarkName,
  endMarkName,
  id,
  detail,
}: {
  metricName: string;
  startMarkName: string;
  endMarkName: string;
  id: string;
  detail?: MeasureDetail;
}): boolean => {
  const start = createMarkForId(startMarkName, id);
  if (!hasMark(start)) {
    return false;
  }

  const end = markOnce(endMarkName, id);
  performance.measure(metricName, { start, end, detail });

  // If you want to persist the marks while debugging locally, comment out the next two lines.
  performance.clearMarks(start);
  performance.clearMarks(end);

  return true;
};
